import { desaturate, transparentize } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { spaceOptions } from './space-options';

const Types = ['success', 'notice', 'error'];
const Icons = {
  success: 0,
  notice: 0,
  error: 0
};

const getSVGForColor = color => {
  return Icons[Types.find(type => type === color)];
};

const styles = props => {
  const renderColor = props.color || 'success';
  const color = props.theme[renderColor];
  const icon = getSVGForColor(renderColor);

  return css`
    display: flex;
    align-items: center;
    padding: 15px 20px;
    border-radius: 5px;
    color: ${props => desaturate(0.4, color) || desaturate(0.4, props.theme.success)};
    border: 1px solid
      ${props => transparentize(0.7, color) || transparentize(0.7, props.theme.success)};
    background-color: ${props =>
      transparentize(0.95, color) || transparentize(0.95, props.theme.success)};
    ${spaceOptions};
    ${icon &&
      `
    &::before {
      content: url(${icon});
      width: 25px;
      height: 25px;
      margin-right: 15px;
    }
    `};
  `;
};
const AlertWrapper = styled.div`
  ${styles};
`;

const Alert = ({ children, ...rest }) => (
  <AlertWrapper {...rest}>
    <div>{children}</div>
  </AlertWrapper>
);

Alert.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node
};

Alert.defaultProps = {
  color: 'success'
};

Alert.displayName = 'Alert';

// notice: if upgrade the hui to V2.71.0+ and install js-package dependence,please use @hipagesgroup/file-upload instead of this

export default Alert;
